import ShareButtons from '../social/ShareButtons';

$(function () {

    let shareButtonsClass = "share-buttons";

    ShareButtons.init(shareButtonsClass);
    ShareButtons.initScroll(shareButtonsClass);
    window.pym.autoInit();

    // Editor cm link hack
    var cmLink = $("#article-content").data('cm');
    if (cmLink) {
        $(document).on('dblclick', '#article-title', function (e) {
            if (e.shiftKey && e.altKey) {
                var win = window.open(cmLink, '_blank');
                win.focus();
            }
        });
    }

    if( $(document).find( '.date__container__left' ).length > 0 ) {
        var dateContainerWidth = $(".date__container").width();
        var dateItem = $(".date__item").width();
        var nbItems = $(".date__item").length;
        var itemsWidth = nbItems * dateItem;

        if(itemsWidth > dateContainerWidth) {
            $(".date__container__displayer").removeClass("hide");
        }
    }

});



// WEBPACK FOOTER //
// ./js/page/MyWortArticlePage.js